'use strict';

/* eslint no-undef: "off" */
/**
 * header 顶部
 */
define('headerQuick',['busEvent', 'countryChoose', 'searchModal', 'getCityListApi', 'util', 'baseSlider', 'changeCityApi', 'getCartApi', 'appStorage', 'GAReport'], function (busEvent, countryChoose, searchModal, getCityListApi, Util, baseSlider, changeCityApi, getCartApi, appStorage, GAReport) {
  return {
    template: '\n      <div class="in-header-quick">\n        <div class="in-container">\n          <div class="in-logo">\n            <a :href="logo.link" @click="onLogoClicked">\n              <img :src="logo.url" alt="">\n            </a>\n          </div>\n          <div class="in-quick-tool-area">\n            <search-modal></search-modal>\n            <div class="in-quick-tool">\n              <div class="in-mini-cart">\n                <a href="/checkout/cart" @click="onCartBtnClicked">\n                  <!--\n                  <i class="xp-iconfont xp-icon-shopping-cart"></i>\n                  -->\n                  <img :src="require.toUrl(\'images/home-cart.png\')" class="home-cart"/>\n                  <span class="in-cart-qty" v-text="cartQty"></span>\n                </a>\n              </div>\n            </div>\n          </div>\n          <div class="in-quick-wrapper">\n            <ul>\n              <li v-if="showLoginRegister">\n                <a class="login-href" :href="loginUrl + \'?mode=login\'" v-text="i18n.login" @click="onUserActionBtnClicked(\'LOGIN\')"></a>\n                <img @click="onCountryBtnClicked" class="current-country"  :src="country.image">\n              </li>\n              <li v-if="showLoginRegister"><a :href="xnLoginUrl" v-text="i18n.register"></a></li>\n              <li v-if="isLogin">\n                <a class="login-href" href="#" v-text="i18n.logout" @click.prevent="logout"></a>\n                <img @click="onCountryBtnClicked" class="current-country"  :src="country.image">\n              </li>\n              <li v-if="isLogin"><a :href="accountUrl" v-text="i18n.account" @click="onUserActionBtnClicked(\'ACCOUNT\')"></a></li>\n              <li><a :href="bbsUrl" target="_blank" v-text="i18n.bbs"></a></li>\n              <li><a :href="orderSearchUrl" v-text="i18n.orderSearch" @click="onUserActionBtnClicked(\'ORDER_SEARCH\')"></a></li>\n              <li class="in-dropdown" @mouseenter="showDropdown" @mouseleave="hideDropdown">\n                <span class="in-dropdown-name">\n                  <span v-text="curCity.name"></span>\n                  <i class="xp-iconfont xp-icon-arrow-down icon-arrow-down"></i>\n                </span>\n                <div class="in-dropdown-content in-dropdown-child" v-if="areaList.length && showDropdownFlag">\n                  <div class="in-dropdown-wrapper">\n                    <div class="in-dropdown-items">\n                    <baseSlider :sliderConfig="sliderConfig">\n                      <div class="swiper-slide">\n                        <ul>\n                          <li\n                          v-for="area in areaList"\n                          :class="[\'in-dropdown-item\', {active: area.is_default}]"\n                          @mouseenter="changeArea(area)"\n                        >\n                          <span\n                            class="in-dropdown-text"\n                            v-text="area.name"\n                            ></span>\n                            <i v-show="area.children.length" class="xp-iconfont xp-icon-arrow-down icon-arrow-down"></i>\n                        </li>\n                      </ul>\n                    </div>\n                  </baseSlider>\n                </div>\n                <div class="in-dropdown-items"  v-show="showDropdownItemFlag">\n                  <baseSlider :sliderConfig="sliderConfig" ref="cityChild">\n                    <div class="swiper-slide">\n                      <ul>\n                        <li\n                          v-for="city in curCityList"\n                            :class="[\'in-dropdown-item\', {active: city.is_default}]"\n                            @click="changeCity(city)"\n                          >\n                            <span\n                              class="in-dropdown-text"\n                              v-text="city.name"\n                              ></span>\n                          </li>\n                        </ul>\n                      </div>\n                    </baseSlider>\n                    </div>\n                    </div>\n                </div>\n              </li>\n              <li class="in-switch-language" ref="switchLangBtn">\n                <span class="currency-text">\n                  <span v-text="currentIsFlag"></span>\n                  <i class="xp-iconfont xp-icon-arrow-down icon-arrow-down" ref="iconArrowDown"></i>\n                </span>\n                <div>\n                  <ul class="in-language-drop-menu">\n                      <li v-for="item in stores"><a :href="item.url" v-text="item.name" @click="onLanguageBtnClicked(item.name)"></a></li>\n                  </ul>\n                </div>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <countryChoose></countryChoose>\n      </div>\n    ',
    data: function data() {
      return {
        welcome: window.commonDataJSON.welcome,
        loginUrl: window.commonDataJSON.login_url,
        bbsUrl: window.commonDataJSON.bbs_forum_link,
        xnLoginUrl: window.commonDataJSON.xn_login_link,
        logoutUrl: '/customer/account/logout/',
        accountUrl: '/customer/account',
        orderSearchUrl: '/searchorder',
        stores: window.commonDataJSON.stores,
        currency: window.commonDataJSON.available_currency,
        isLogin: '',
        i18n: {
          login: 'LOGIN',
          register: 'REGISTER',
          logout: 'LOGOUT',
          account: 'ACCOUNT',
          orderSearch: 'ORDER SEARCH',
          bbs: 'XPARKers'
        },
        isLangDropShow: false,
        isLogoutSuccess: window.isLogoutSuccess ? window.isLogoutSuccess : false,
        logo: window.commonDataJSON.logo,
        cartQty: 0,
        showSearchBtn: true,
        country: {},
        countries: [],
        sliderConfig: {
          isScrollbar: true,
          coreSliderConfig: {
            direction: 'vertical',
            slidesPerView: 'auto',
            freeMode: true,
            scrollbar: {
              el: '.swiper-scrollbar'
            },
            mousewheel: true
          }
        },
        areaList: [],
        curCityList: [],
        showDropdownFlag: false,
        showDropdownItemFlag: false,
        curCity: {
          name: 'CITY',
          id: ''
        }
      };
    },
    created: function created() {
      getCityListApi().then(this.flashCity.bind(this));
      getCartApi().then(this.flashCart.bind(this));
    },
    mounted: function mounted() {
      var _this = this;

      this.countries = window.commonDataJSON.xpark_webs || [];
      var arr = this.countries.filter(function (item) {
        return item.isCurrent;
      });
      if (arr.length > 0) {
        this.country = arr[0];
      }
      busEvent.$on('changeCity', function (city) {
        _this.curCity = city;
      });
      this.isLogin = appStorage.get('token');
      appStorage.onChange('cart', this.flashCart.bind(this));
      appStorage.onChange('customer', this.flashCustomer.bind(this));
      appStorage.onChange('city_list', this.flashCity.bind(this));
    },

    components: {
      countryChoose: countryChoose,
      searchModal: searchModal,
      baseSlider: baseSlider
    },
    computed: {
      currentIsFlag: function currentIsFlag() {
        for (var item in this.stores) {
          if (this.stores[item]['is_active'] && this.stores[item]['choosed']) {
            return this.stores[item]['name'];
          }
        }
      },
      showLoginRegister: function showLoginRegister() {
        if (!this.isLogin && this.isLogoutSuccess) {
          return false;
        } else if (!this.isLogin) {
          return true;
        } else {
          return false;
        }
      }
    },
    methods: {
      flashCart: function flashCart(aft) {
        if (aft) {
          this.cartQty = aft.count;
        }
      },
      flashCustomer: function flashCustomer(aft) {
        if (aft) {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
      },
      flashCity: function flashCity(aft) {
        if (aft) {
          this.areaList = aft;
          this.filterCurCity();
        }
      },
      filterCurCity: function filterCurCity() {
        this.curCity = this.areaList.filter(function (area) {
          return area.is_default;
        })[0].children.filter(function (city) {
          return city.is_default;
        })[0];
        this.curCityList = this.curCity.children;
      },
      showDropdown: function showDropdown() {
        this.showDropdownFlag = !this.showDropdownFlag;
      },
      hideDropdown: function hideDropdown() {
        this.showDropdownFlag = false;
        this.showDropdownItemFlag = false;
      },
      changeArea: function changeArea(area) {
        var _this2 = this;

        this.curCityList = area.children;
        this.showDropdownItemFlag = true;
        setTimeout(function () {
          _this2.showDropdownFlag && _this2.$refs['cityChild'].$slider.update();
        }, 100);
      },
      changeCity: function changeCity(city) {

        city.id && changeCityApi({ cityId: city.id }).then(function (resData) {
          getCityListApi();
          getCartApi();
        });

        if (city.name) {
          new GAReport().customerClick({
            eventAction: 'TOP_CHANGE_SHIP_CITY_TO_' + city.name,
            eventCategory: 'CHANGE_SHIP_CITY_#VERSION#'
          });
        }
      },
      logout: function logout() {
        appStorage.clear();
        this.onUserActionBtnClicked('LOGOUT');
        Util.redirect(this.logoutUrl);
      },
      onLogoClicked: function onLogoClicked() {
        new GAReport().customerClick({
          eventAction: 'PAGE_#PAGEGROUP#',
          eventCategory: 'ICON_#VERSION#_CLICK'
        });
      },

      // 购物车图标点击事件
      onCartBtnClicked: function onCartBtnClicked() {
        new GAReport().customerClick({
          eventAction: 'TOP_CART_ENTRY',
          eventCategory: 'TOP_CART_#VERSION#'
        });
      },
      onCountryBtnClicked: function onCountryBtnClicked() {
        new GAReport().customerClick({
          eventAction: 'TOP_COUNTRY_CHANGE_ENTRY',
          eventCategory: 'TOP_COUNTRY_CHANGE_#VERSION#'
        });
        busEvent.$emit('showCountryModal');
      },
      onUserActionBtnClicked: function onUserActionBtnClicked(action) {
        new GAReport().customerClick({
          eventAction: 'TOP_ENTRY_' + action,
          eventCategory: 'USER_#VERSION#'
        });
      },
      onLanguageBtnClicked: function onLanguageBtnClicked(language) {
        new GAReport().customerClick({
          eventAction: 'TOP_CHANGE_LANGUAGE_TO_' + language,
          eventCategory: 'CHANGE_LANGUAGE_#VERSION#'
        });
      }
    }
  };
});
